var Q = Object.defineProperty, T = Object.defineProperties;
var U = Object.getOwnPropertyDescriptors;
var f = Object.getOwnPropertySymbols;
var I = Object.prototype.hasOwnProperty, O = Object.prototype.propertyIsEnumerable;
var $ = (e, s, a) => s in e ? Q(e, s, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[s] = a, t = (e, s) => {
  for (var a in s || (s = {}))
    I.call(s, a) && $(e, a, s[a]);
  if (f)
    for (var a of f(s))
      O.call(s, a) && $(e, a, s[a]);
  return e;
}, d = (e, s) => T(e, U(s));
var R = (e, s) => {
  var a = {};
  for (var o in e)
    I.call(e, o) && s.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && f)
    for (var o of f(e))
      s.indexOf(o) < 0 && O.call(e, o) && (a[o] = e[o]);
  return a;
};
import { jsx as y, jsxs as W } from "react/jsx-runtime";
import "react";
import { c as g, e as X } from "./get-size-Bc1Pz5yf.js";
import { c as V } from "./create-vars-resolver-Bzbn9G-G.js";
import { f as q, u as A, B as E } from "./factory-ueRxoNOV.js";
import { u as F } from "./use-styles-DToiHEa6.js";
import { C as Y } from "./CloseButton-BysQSF2E.js";
import { c as H } from "./create-optional-context-CQ2ahjKQ.js";
const [us, J] = H(), [Z, B] = H();
var v = { root: "m_7cda1cd6", "root--default": "m_44da308b", "root--contrast": "m_e3a01f8", label: "m_1e0e6180", remove: "m_ae386778", group: "m_1dcfd90b" };
const ss = {}, as = V((e, { gap: s }, { size: a }) => ({
  group: {
    "--pg-gap": s !== void 0 ? g(s) : g(a, "pg-gap")
  }
})), S = q((e, s) => {
  const a = A("PillGroup", ss, e), u = a, { classNames: o, className: z, style: h, styles: _, unstyled: p, vars: b, size: P, disabled: N } = u, m = R(u, ["classNames", "className", "style", "styles", "unstyled", "vars", "size", "disabled"]), i = J(), l = (i == null ? void 0 : i.size) || P || void 0, C = F({
    name: "PillGroup",
    classes: v,
    props: a,
    className: z,
    style: h,
    classNames: o,
    styles: _,
    unstyled: p,
    vars: b,
    varsResolver: as,
    stylesCtx: { size: l },
    rootSelector: "group"
  });
  return /* @__PURE__ */ y(Z, { value: { size: l, disabled: N }, children: /* @__PURE__ */ y(E, t(t({ ref: s, size: l }, C("group")), m)) });
});
S.classes = v;
S.displayName = "@mantine/core/PillGroup";
const es = {
  variant: "default"
}, ls = V((e, { radius: s }, { size: a }) => ({
  root: {
    "--pill-fz": g(a, "pill-fz"),
    "--pill-height": g(a, "pill-height"),
    "--pill-radius": s === void 0 ? void 0 : X(s)
  }
})), w = q((e, s) => {
  const a = A("Pill", es, e), M = a, {
    classNames: o,
    className: z,
    style: h,
    styles: _,
    unstyled: p,
    vars: b,
    variant: P,
    children: N,
    withRemoveButton: m,
    onRemove: i,
    removeButtonProps: l,
    radius: C,
    size: u,
    disabled: D,
    mod: K
  } = M, L = R(M, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "variant",
    "children",
    "withRemoveButton",
    "onRemove",
    "removeButtonProps",
    "radius",
    "size",
    "disabled",
    "mod"
  ]), r = B(), G = J(), j = u || (r == null ? void 0 : r.size) || void 0, k = (G == null ? void 0 : G.variant) === "filled" ? "contrast" : P || "default", x = F({
    name: "Pill",
    classes: v,
    props: a,
    className: z,
    style: h,
    classNames: o,
    styles: _,
    unstyled: p,
    vars: b,
    varsResolver: ls,
    stylesCtx: { size: j }
  });
  return /* @__PURE__ */ W(
    E,
    d(t(d(t({
      component: "span",
      ref: s,
      variant: k,
      size: j
    }, x("root", { variant: k })), {
      mod: [
        { "with-remove": m && !D, disabled: D || (r == null ? void 0 : r.disabled) },
        K
      ]
    }), L), {
      children: [
        /* @__PURE__ */ y("span", d(t({}, x("label")), { children: N })),
        m && /* @__PURE__ */ y(
          Y,
          d(t(t({
            variant: "transparent",
            radius: C,
            tabIndex: -1,
            "aria-hidden": !0,
            unstyled: p
          }, l), x("remove", {
            className: l == null ? void 0 : l.className,
            style: l == null ? void 0 : l.style
          })), {
            onMouseDown: (n) => {
              var c;
              n.preventDefault(), n.stopPropagation(), (c = l == null ? void 0 : l.onMouseDown) == null || c.call(l, n);
            },
            onClick: (n) => {
              var c;
              n.stopPropagation(), i == null || i(), (c = l == null ? void 0 : l.onClick) == null || c.call(l, n);
            }
          })
        )
      ]
    })
  );
});
w.classes = v;
w.displayName = "@mantine/core/Pill";
w.Group = S;
export {
  w as P,
  us as a,
  J as u
};
